import type { JSX } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

/**
 * Редиректы старых адресов админ-экранов на вкладки HUB 2.0 (волна W5).
 * Отдельный лёгкий файл: App.tsx импортирует их статически, а сами страницы
 * (WikiAdminPage, UsersPage) остаются ленивыми чанками.
 *
 * Маршруты подключает W1 в App.tsx, например:
 *   <Route path="/admin/archive" element={<AdminTabRedirect tab="archive" />} />
 *   <Route path="/admin/roles" element={<UsersTabRedirect tab="roles" />} />
 */
export const ADMIN_TABS = ['blocks', 'tags', 'archive', 'templates', 'criteria', 'import', 'edits', 'graph', 'synonyms', 'notify', 'ai'] as const;
export type AdminTab = (typeof ADMIN_TABS)[number];

function withTab(base: string, tab: string, sp: URLSearchParams): string {
  const next = new URLSearchParams(sp);
  next.set('tab', tab);
  return `${base}?${next.toString()}`;
}

/** /admin/archive, /admin/documents, /admin/room-criteria, /admin/inbox, /admin/suggested-edits → /admin/wiki?tab=… */
export function AdminTabRedirect({ tab }: { tab: AdminTab }): JSX.Element {
  const [sp] = useSearchParams();
  return <Navigate to={withTab('/admin/wiki', tab, sp)} replace />;
}

/** /admin/roles → /admin/users?tab=roles («Пользователи и роли» — один пункт меню). */
export function UsersTabRedirect({ tab }: { tab: 'users' | 'roles' }): JSX.Element {
  const [sp] = useSearchParams();
  return <Navigate to={withTab('/admin/users', tab, sp)} replace />;
}
